const getDefaultState = () => {
  return {
    gates: [],
    ultimasPesagens: [],
  }
}

export default getDefaultState
